/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable fp/no-mutation */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import merge from 'lodash.merge';
import { commonMessages } from '../messages/common';
import { comparisonTableVersusMessages } from '../messages/comparison-table-versus';
export const ComparisonTableVersusTranslations = merge(undefined, commonMessages, comparisonTableVersusMessages);
